import React, { useEffect, useMemo, useState } from "react"
import dayjs from "dayjs"
import PropTypes from "prop-types"
import PriceService from "src/services/price-service"
import { columnsPrecoVariacaoDiaria } from "./tabela-preco-variacao-constants"
import DataGridTable from "../../../../components/Table/data-grid-table"
import { dispatchSnackbar } from "../../../../components/SnackBar/snackbar-bus"

const TabelaPrecoVariacao = ({ date, setLoading, setExportFileCsv, loading }) => {
    const priceService = useMemo(() => new PriceService(), [])
    const [priceList, setPriceList] = useState([])

    useEffect(() => {
        if (!date || !dayjs(date).isValid()) return

        let ignoreResponse = false

        setExportFileCsv(() => () => priceService.exportDataVariationToCsv(date))

        const loadPrices = async () => {
            setLoading(true)
            try {
                const response = await priceService.loadTablePriceVariantion(date, date)
                const { body } = response
                const { data } = body
                const rows = data.map((obj, index) => ({ ...obj, id: index }))

                if (ignoreResponse) return

                setPriceList(rows)
            } catch {
                if (ignoreResponse) return

                setPriceList([])
                dispatchSnackbar("Não foi possível carregar a variação diária de preços.", "error")
            } finally {
                if (!ignoreResponse) setLoading(false)
            }
        }

        loadPrices()

        return () => {
            ignoreResponse = true
        }
    }, [date, priceService, setExportFileCsv, setLoading])

    return (
        <DataGridTable
            rows={priceList}
            columns={columnsPrecoVariacaoDiaria()}
            loading={loading}
            contained
            autoRowHeight
            rowPadding={2}
            pointerCursor
            disableRowSelectionOnClick
            sortingOrder={['asc', 'desc']}
        />
    )
}

TabelaPrecoVariacao.propTypes = {
    date: PropTypes.string,
    setLoading: PropTypes.func,
    loading: PropTypes.bool,
    setExportFileCsv: PropTypes.func,
}

export default TabelaPrecoVariacao
